import React, { useEffect, useState } from "react";
import DefectiveTerminalDetails from "./DefectiveTerminalDetails";
import Consumer from "./Consumer";
import { useParams } from "react-router-dom";
import { getTime, getTime12Hour } from "../../Helpers/Utils/Common";
import Summary from "./Summary";
import MayaTerminalSolutionDetails from "./MayaTerminalSolutionDetails";
import {
  getAccounts,
  getFreebies,
  getPromos,
  getDropdownData,
  getAllMerchants,
  getAllOutlets,
} from "../../Helpers/API/formsAPI";
import RegistrationVer2 from "./RegistrationVer2";
import SummaryVer2 from "./SummaryVer2";
import MayaGoogleForm from "./MayaGoogleForm";
import MerchantDetails from "./MerchantDetails";
import RegionForm from "./RegionForm";
import MallSelector from "./MallSelector";
import MerchantLocation from "./MerchantLocation";
import TerminalAvailability from "./TerminalAvailability";
import SQRAvailability from "./SQRAvailability";
import TerminalConcerns from "./TerminalConcerns";
import CompetitorMerch from "./CompetitorMerch";
import CompetitorPromoConsumers from "./CompetitorPromoConsumers";
import CompetitorPromoMerchant from "./CompetitorPromoMerchant";
import MayaMallProgramCIP from "./MayaMallProgramCIP";
import MayaMallProgramSection70 from "./MayaMallProgramSection70";
import JoiningMayaMallProgramSection72 from "./JoiningMayaMallProgramSection72";
import CompetitorPriority from "./CompetitorPriority";
import OtherMallDetails from "./OtherMallDetails";
import IndustryTypeStore from "./IndustryTypeStore";
import CanEngage from "./CanEngage";
import CantEngageRemarks from "./CantEngageRemarks";
import TypeOfMerchant from "./TypeOfMerchant";
import MayaSolution from "./MayaSolution";
import InterestedMayaSolution from "./InterestedMayaSolution";
import NotInterestedMayaSolution from "./NotInterestedMayaSolution";
import NonMayaMerchantInfo from "./NonMayaMerchantInfo";
import WorkingTerminalDetails from "./WorkingTerminalDetails";
import ThermalRoll from "./ThermalRoll";
import P1StandeeMerchandisingPage from "./P1StandeeMerchandisingPage";
import NotVisibleP1Standee from "./NotVisibleP1Standee";
import P1StandeeDetails from "./P1StandeeDetails";
import P1DoorHangerMerchandisingPage from "./P1DoorHangerMerchandisingPage";
import NotVisibleP1DoorHangerPage from "./NotVisibleP1DoorHangerPage";
import P1DoorHangerDetailsPage from "./P1DoorHangerDetailsPage";
import P1DoorStickerMerchandisingPage from "./P1DoorStickerMerchandisingPage";
import NotVisibleP1DoorStickerPage from "./NotVisibleP1DoorStickerPage";
import PointOfContact from "./PointOfContact";
import NotJoiningMayaMallProgram from "./NotJoiningMayaMallProgram";
import TerminalStickering from "./TerminalStickering";
import TerminalStickeringDetails from "./TerminalStickeringDetails";
import WastedTerminalSticker from "./WastedTerminalSticker";

import ThermalRollDeliveryPage from "./ThermalRollDeliveryPage";
import ChargerDelivery from "./ChargerDelivery";
import ChargerDeliveryYesPage from "./ChargerDeliveryYesPage";
import RevisitDetails from "./RevisitDetails";
import InstallP1TerminalMerch from "./InstallP1TerminalMerch";
import NotInstalledP1DoorSticker from "./NotInstalledP1DoorSticker";
import InstalledP1DoorSticker from "./InstalledP1DoorSticker";
import QRPHKnowledge from "./QRPHKnowledge";
import MayaSQRSolution from "./MayaSQRSolution";
import MayaSQRSolutionDetails from "./MayaSQRSolutionDetails";
import UpdatedSQR from "./UpdatedSQR";
import SQRBrandingVersion from "./SQRBrandingVersion";
import SQRPhoto from "./SQRPhoto";
import QRPHDoorHangerMerch from "./QRPHDoorHangerMerch";
import QRPHDoorHangerDetails from "./QRPHDoorHangerDetails";
import NotVisbleQRPH from "./NotVisbleQRPH";
import QRPHDoorStickerMerch from "./QRPHDoorStickerMerch";
import QRPHDoorStickerDetails from "./QRPHDoorStickerDetails";
import P1DoorStickerDetails from "./P1DoorStickerDetails";
import NotVisibleQRPHDoorSticker from "./NotVisibleQRPHDoorSticker";
import InstalledQRPHDoorSticker from "./InstalledQRPHDoorSticker";
import NotInstalledQRPHDoorSticker from "./NotInstalledQRPHDoorSticker";
import InstallSQRMerch from "./InstallSQRMerch";
import ViberAccount from "./ViberAccount";
import MayaAccount from "./MayaAccount";
import MayaAccountDetails from "./MayaAccountDetails";
import MayaKitaClub from "./MayaKitaClub";
import HandlingAndMerchantConcerns from "./HandlingAndMerchantConcerns";
import MayaMerchantSurvey from "./MayaMerchantSurvey";
import NonMayaMerchantsSurvey from "./NonMayaMerchantsSurvey";
import ZeroToLowMerchant from "./ZeroToLowMerchant";
import ZeroToLowMerchantYes from "./ZeroToLowMerchantYes";
import VisibilityPhoto from "./VisibilityPhoto";
import DCCFlyer from "./DCCFlyer";
import MayaKitaClubFlyer from "./MayaKitaClubFlyer";
import DCCFlyerPhoto from "./DCCFlyerPhoto";   
import MayaKitaClubFlyerPhoto from "./MayaKitaClubFlyerPhoto";
import TroubleshootQRSticker from "./TroubleshootQRSticker";
import TroubleshootQRStickerPhoto from "./TroubleshootQRStickerPhoto";
import TroubleShootP1Sticker from "./TroubleShootP1Sticker";
import TroubleshootP1StickerPhoto from "./TroubleshootP1StickerPhoto";
import Remarks from "./Remarks";
import PromotionalActivity from "./PromotionalActivity";
import AwardingMerienda from "./AwardingMerienda";
import AwardingFeedback from "./AwardingFeedback";
import AwardingMayaCredit from "./AwardingMayaCredit";
import AwardingDetails from "./AwardingDetails";
import AwardingFlagship from "./AwardingFlagship";
import FlagshipFeedback from "./FlagshipFeedback";
import Merchandising from "./Merchandising";
import MayaBlack from "./MayaBlack";
import MerchantOtherSolution from "./Merchantothersolution";
import VisibilityOfTerminalMerch from "./VisibilityOfTerminalMerch";
import VisibilityOfSQRMerch from "./VisibilityOfSQRMerch";

const steps = [
    { id: "maya-form" },
    { id: "merchant-details" },
    { id: "region-form" },
    { id: "mall-selector" },
    { id: "other-mall-details" },
    { id: "industry-type-store" },
    { id: "can-engage" },
    { id: "cant-engage-remarks" },
    { id: "revisit-details" },
    { id: "type-of-merchant" },
    { id: "non-maya-merchants-survey" },
    { id: "maya-solution" },
    { id: "terminal-availability" },
    { id: "sqr-availability" },
    // moved: terminal-concerns after handling-and-merchant-concerns
    { id: "competitor-merch" },
    { id: "competitor-promo-consumers" },
    { id: "competitor-promo-merchant" },
    { id: "maya-terminal-solution-details" },
    { id: "defective-terminal-details" },
    { id: "working-terminal-details" },
    { id: "thermal-roll" },
    { id: "thermal-roll-delivery-yes" },
    { id: "charger-delivery" },
    { id: "charger-delivery-yes" },
    { id: "p1-standee-merchandising" },
    { id: "not-visible-p1-standee" },
    { id: "p1-standee-details" },
    { id: "p1-door-hanger-merchandising" },
    { id: "not-visible-p1-door-hanger" },
    { id: "p1-door-hanger-details" },
    { id: "p1-door-sticker-merchandising" },
    { id: "p1-door-sticker-details" },
    { id: "not-visible-p1-door-sticker" },
    { id: "install-p1-terminal-merch" },
    { id: "installed-p1-door-sticker" },
    { id: "not-installed-p1-door-sticker" },
    { id: "qrph-knowledge" },
    { id: "maya-sqr-solution" },
    { id: "maya-sqr-solution-details" },
    { id: "merchandising" },
    { id: "maya-black" },
    { id: "merchant-other-solution" },
    { id: "visibility-of-terminal-merch" },
    { id: "visibility-of-sqr-merch" },
    { id: "updated-sqr" },
    { id: "sqr-branding-version" },
    { id: "sqr-photo" },
    { id: "qrph-door-hanger-merch" },
    { id: "qrph-door-hanger-details" },
    { id: "not-visible-qrph" },
    { id: "qrph-door-sticker-merch" },
    { id: "qrph-door-sticker-details" },
    { id: "not-visible-qrph-door-sticker" },
    { id: "installed-qrph-door-sticker" },
    { id: "not-installed-qrph-door-sticker" },
    { id: "install-sqr-merch" },
    { id: "interested-maya-solution" },
    { id: "non-maya-merchant-info" },
    { id: "not-interested-maya-solution" },
    { id: "merchant-location" },
    { id: "maya-mall-program-cip" },
    { id: "maya-mall-program-section-70" },
    { id: "joining-maya-mall-program-section-72" },
    { id: "competitor-priority" },
    { id: "not-joining-maya-mall-program" },
    { id: "point-of-contact" },
    { id: "viber-account" },
    { id: "maya-account" },
    { id: "maya-account-details" },
    { id: "maya-kita-club" },
    { id: "handling-and-merchant-concerns" },
    { id: "maya-merchant-survey" },
    { id: "terminal-concerns" },
    { id: "zero-to-low-merchant" },
    { id: "zero-to-low-merchant-yes" },
    { id: "visibility-photo" },
    { id: "dcc-flyer" },
    { id: "dcc-flyer-photo" },
    { id: "maya-kita-club-flyer" },
    { id: "maya-kita-club-flyer-photo" },
    { id: "troubleshoot-qr-sticker" },
    { id: "troubleshoot-qr-sticker-photo" },
    { id: "troubleshoot-p1-sticker" },
    { id: "troubleshoot-p1-sticker-photo" },
    { id: "remarks" },
    { id: "promotional-activity" },
    { id: "awarding-merienda" },
    { id: "awarding-feedback" },
    { id: "awarding-maya-credit" },
    { id: "awarding-details" },
    { id: "awarding-flagship" },
    { id: "flagship-feedback" },
    { id: "registration" },
    // { id: "consumer" },
    { id: "terminal-stickering-details" },
    { id: "wasted-terminal-sticker" },

    { id: "terminal-stickering" },
    { id: "summary" }
];

// Custom hook to replace react-hooks-helper with localStorage persistence
function useStep({ steps, initialStep = 0 }) {


  const [currentStepIndex, setCurrentStepIndex] = useState(initialStep); // always 0
  const [history, setHistory] = useState([]); // always empty


  const step = steps[currentStepIndex];

  const navigation = {
    // Push the current step onto history before moving forward
    next: () => {
      if (currentStepIndex < steps.length - 1) {
        setHistory((prev) => [...prev, currentStepIndex]);
        setCurrentStepIndex(currentStepIndex + 1);
      }
    },
    // Pop from history to truly go back to last visited step
    previous: () => {
      setHistory((prev) => {
        if (prev.length > 0) {
          const lastIndex = prev[prev.length - 1];
          setCurrentStepIndex(lastIndex);
          return prev.slice(0, -1);
        } else {
          // Fallback to simple index decrement if no history
          if (currentStepIndex > 0) {
            setCurrentStepIndex(currentStepIndex - 1);
          }
          return prev;
        }
      });
    },
    // Push current onto history then go to the requested step
    go: (stepId) => {
      console.log("Navigation.go called with stepId:", stepId);
      const stepIndex = steps.findIndex((s) => s.id === stepId);
      console.log("Found step index:", stepIndex);
      if (stepIndex !== -1) {
        setHistory((prev) => [...prev, currentStepIndex]);
        console.log("Setting current step index to:", stepIndex);
        setCurrentStepIndex(stepIndex);
      } else {
        console.log("Step not found in steps array");
      }
    },
    reset: () => {
      setCurrentStepIndex(0);
      setHistory([]);
      try {
        localStorage.removeItem('maya-form-current-step');
        localStorage.removeItem('maya-form-data');
        localStorage.removeItem('maya-form-history');
      } catch (error) {
        console.warn('Error clearing localStorage:', error);
      }
    }
  };

  return { step, navigation };
}

function SwitchForm() {
  // State for terminal stickering
  const [stickeringDetails, setStickeringDetails] = useState({
    description: '',
    reason: '',
    details: '',
  });
  const [stickeringError, setStickeringError] = useState({});
  const { step, navigation } = useStep({
    steps,
    initialStep: 0,
  });

  const [addCustomer, setAddCustomer] = useState(false);
  const [formId, setFormId] = useState("");
  const [selectedEscalationIssues, setSelectedEscalationIssues] = useState([]);
  const [outlets, setOutlets] = useState([
    // {
    // 	name: "outlet_id",
    //   var_name: "outlet",
    // 	label: "choice 1",
    // 	value: "choice 1",
    // },
    // {
    // 	name: "outlet_id",
    //   var_name: "outlet",
    // 	label: "choice 2",
    // 	value: "choice 2",
    // },
    // {
    // 	name: "outlet_id",
    //   var_name: "outlet",
    // 	label: "choice 3",
    // 	value: "choice 3",
    // },
    // {
    // 	name: "outlet_id",
    //   var_name: "outlet",
    // 	label: "choice 4",
    // 	value: "choice 4",
    // },
    // {
    // 	name: "outlet_id",
    //   var_name: "outlet",
    // 	label: "choice 5",
    // 	value: "choice 5",
    // },
    // {
    // 	name: "outlet_id",
    //   var_name: "outlet",
    // 	label: "Others",
    // 	value: "Others",
    // },
  ]);
  const [issues, setIssues] = useState([]);



    // Function to load saved form data from localStorage
    const loadSavedFormData = () => {
      try {
        const savedData = localStorage.getItem('maya-form-data');
        if (savedData) {
          const parsedData = JSON.parse(savedData);

          const loadSavedFormData = () => {
          try {
            const savedData = localStorage.getItem('maya-form-data');
            if (savedData) {
              return JSON.parse(savedData);
              // temp_paths are strings, they restore automatically ✅
            }
          } catch (error) {
            console.warn('Error loading saved form data:', error);
          }
          return null;
        };

          return parsedData;
        }
      } catch (error) {
        console.warn('Error loading saved form data:', error);
      }
      return null;
    };

  const [primaryDetails, setPrimaryDetails] = useState(() => {
    const savedData = loadSavedFormData();
    const defaultData = {
    // Maya Google Form fields
    date_of_visit: "",
    time_of_visit: "",
    activity_name: "",
    tas_name: "",

    // Merchant Details fields
    description: "",
    procast_code: "",
    brn_company_file: null,
    brn_company_name_text: "",
    lf_dba_store_name: "",
    region: "",

    // North Luzon fields
    description_north_luzon: "",
    province: "",
    municipality: "",
    mall_type: "",

    // North Luzon Malls fields
    description_north_luzon_malls: "",
    north_luzon_mall_name: "",

    // North NCR fields
    description_north_ncr: "",
    province_ncr: "",
    municipality_ncr: "",
    mall_type_ncr: "",

    // North NCR Malls fields
    description_north_ncr_malls: "",
    north_ncr_mall_name: "",

    // Rizal NCR fields
    description_rizal_ncr: "",
    province_rizal: "",
    municipality_rizal: "",
    mall_type_rizal: "",

    // Rizal NCR Malls fields
    description_rizal_ncr_malls: "",
    rizal_ncr_mall_name: "",

    // South NCR fields
    description_south_ncr: "",
    province_south_ncr: "",
    municipality_south_ncr: "",
    mall_type_south_ncr: "",

    // South NCR Malls fields
    description_south_ncr_malls: "",
    south_ncr_mall_name: "",

    // South Luzon fields
    description_south_luzon: "",
    province_south_luzon: "",
    municipality_south_luzon: "",
    mall_type_south_luzon: "",

    // South Luzon Malls fields
    description_south_luzon_malls: "",
    south_luzon_mall_name: "",

    // Visayas fields
    description_visayas: "",
    province_visayas: "",
    municipality_visayas: "",
    mall_type_visayas: "",

    // Visayas Malls fields
    description_visayas_malls: "",
    visayas_mall_name: "",

    // Mindanao fields
    description_mindanao: "",
    province_mindanao: "",
    municipality_mindanao: "",
    mall_type_mindanao: "",

    // Mindanao Malls fields
    description_mindanao_malls: "",
    mindanao_mall_name: "",

    // Other Mall Details fields
    other_mall_name: "",
    slot_floor: "",

    // Industry & Type of Store fields
    description_industry_type: "",
    industry: "",
    type_of_store: "",

    // Merchant Location fields (Section 17)
    description_merchant_location: "",
    building_name_standalone: "",
    complete_address: "",
    landmark: "",
    coordinates: "",
    merchant_google_map_link: "",
    merchant_link_type: "",

    // Original fields
    // classification_type: "",
    serial_numbers: [],
    store_codes: [],
    other_competitor: [],
    file_names: [],
    escalation_issues: "",
    available_terminal_other_details: "",
    solution_device_other_details: "",
    own_merchandising_other_details: "",
    merchant_concern_other_details: "",
    servicing_other_details: "",
    merchandising_request_other_details: "",
    merchant_mid_sqr: "",
    merchant_mid_terminal: "",
    sn_terminal: "",
    store_code: "",
    date: new Date().toISOString().split("T")[0],
    selected_outlet:[{label:"", value:""}],

    // Can Engage fields
    can_engage: "",
    cant_engage_remarks: "",
    type_of_merchant: "",
    maya_solution: "",
    interested_maya_solution: "",
    not_interested_reason: "",
    merchant_transaction: "",

    // Maya Merchant Survey fields
    maya_terminal_preference: "",
    prefer_maya_reasons: [],
    prefer_maya_other: "",
    preferred_payment_terminal: "",
    preferred_payment_terminal_other: "",
    not_prefer_maya_reasons: [],
    not_prefer_maya_other: "",
    choose_preferred_terminal_reasons: [],
    choose_preferred_terminal_other: "",
    influence_prefer_maya: [],
    influence_prefer_maya_other: "",

    // Non Maya Merchants Survey fields
    non_maya_preferred_terminal: "",
    non_maya_preferred_terminal_other: "",
    non_maya_choose_preferred_reasons: [],
    non_maya_choose_preferred_other: "",
    non_maya_not_accept_maya_reasons: [],
    non_maya_not_accept_maya_other: "",

    // Non Maya Merchant Info fields
    non_maya_merchant_type: "",
    registration_type: "",
    photo_2303: null,
    estimated_monthly_sales: "",
    disclosure_reason: "",

    // Working Terminal Details fields
    working_count: "",
    terminal_ids: "",
    serial_nos: "",
    battery_charge: "",
    stickering: "",

    // Terminal Stickering Details fields
    stickering_details_description: "",
    terminals_stickered_count: "",
    p1_front_before_photo_temp_path: "",
    p1_back_before_photo_temp_path: "",
    p1_front_after_photo_temp_path: "",
    p1_back_after_photo_temp_path: "",
    wasted_photo_temp_path: "",
    thermal_roll_photo_temp_path: "",
    thermal_roll_delivery_receipt_temp_path: "",
    thermal_roll_escalation_photo_temp_path: "",
    charger_request_photo_temp_path: "",
    charger_delivery_receipt_temp_path: "",
    counter_top_photo_temp_path: "",
    store_type_photo_temp_path: "",
    store_photo_temp_path: "",
    consumer_promo_photo_temp_path: "",
    merchant_promo_photo_temp_path: "",
    promo_merch_mats_temp_path: "",
    store_front_photo_temp_path: "",
    registration_photo_temp_path: "",
    photo_2303_temp_path: "",
    maya_account_photo_temp_path: "",
    acknowledgement_receipt_temp_path: "",
    merienda_purchase_receipt_temp_path: "",
    merienda_certificate_temp_path: "",
    flagship_freebies_temp_path: "",
    verified_maya_account_photo_temp_path: "",
    received_maya_credit_photo_temp_path: "",
    maya_account_name_photo_temp_path: "",
    maya_account_number_photo_temp_path: "",
    maya_account_position_photo_temp_path: "",
    credit_certificate_temp_path: "",
    amount_transferred_temp_path: "",
    reference_no_temp_path: "",
    upload_company_id_temp_path: "",
    sqr_photo_temp_path: "",
    installed_p1_door_sticker_photo_temp_path: "",
    qrph_door_sticker_installed_photo_temp_path: "",
    dcc_photo_temp_path: "",
    qr_sticker_distribution_photo_temp_path: "",
    p1_sticker_photo_temp_path: "",
    flyer_distribution_photo_temp_path: "",
    maya_black_merchandising_type: "",
    maya_black_merchandising_branding: "",
    location: "",
    is_grab_merchant: "",
    is_food_panda_merchant: "",
    wasted_terminal_sticker: "",

    // Wasted Terminal Sticker fields
    wasted_sticker_description: "",
    wasted_sticker_count: "",
    wasted_sticker_reason: "",

    // Thermal Roll Delivery fields
    thermal_roll_delivery: "",
    thermal_roll_delivery_description: "",
    thermal_roll_no: "",

    // Charger Delivery fields
    charger_delivery: "",
    charger_delivery_description: "",
    charger_case_no: "",

    // P1 Standee Merchandising fields
    p1_standee_description: "",
    standee_visible: "",
    // NOT VISIBLE P1 STANDEE section fields
    not_visible_p1_description: "",
    standee_unvisible_reason: "",
    other_reason_p1_not_visible: "",
    // P1 STANDEE DETAILS section fields
    p1_standee_details_description: "",
    standee_location: "",
    standee_brand: "",
    standee_count: "",

    // P1 Door Sticker Merchandising fields
    p1_door_sticker_description: "",
    door_sticker_visible: "",

    // Maya Black fields
    // maya_black_merchandising_type: "",
    // maya_black_merchandising_branding: ""
    };

    // Return merged data (saved data takes precedence over defaults)
    return savedData ? { ...defaultData, ...savedData } : defaultData;
  });

  // Save form data to localStorage whenever it changes (including file objects as base64)
  useEffect(() => {
    try {
      // Remove File objects before saving to localStorage
      // temp_paths (strings) are fine to keep - they persist ✅
      const dataToSave = { ...primaryDetails };

      // Only remove actual File objects (not temp_path strings)
      Object.keys(dataToSave).forEach(key => {
        if (dataToSave[key] instanceof File || dataToSave[key] instanceof Blob) {
          dataToSave[key] = null;
        }
      });

      // Clean File objects from working_terminals array
      if (dataToSave.working_terminals && Array.isArray(dataToSave.working_terminals)) {
        dataToSave.working_terminals = dataToSave.working_terminals.map(terminal => {
          const cleaned = { ...terminal };
          Object.keys(cleaned).forEach(key => {
            if (cleaned[key] instanceof File || cleaned[key] instanceof Blob) {
              cleaned[key] = null;
            }
          });
          return cleaned;
        });
      }
      localStorage.setItem('maya-form-data', JSON.stringify(dataToSave));
    } catch (error) {
      console.warn('Error saving form data to localStorage:', error);
    }
  }, [primaryDetails]);

  // Function to clear all saved data (call when form is completed or reset)
    const clearFormData = () => {
      try {
        localStorage.removeItem('maya-form-data');
        localStorage.removeItem('maya-form-details');
        localStorage.removeItem('maya-form-current-step');
        localStorage.removeItem('maya-form-history');      // ADD THIS
        localStorage.removeItem('maya_form_backup');
      } catch (error) {
        console.warn('Error clearing form data:', error);
      }
    };

    

    // Clear on browser/tab close
    useEffect(() => {
      const handleBeforeUnload = () => {
        clearFormData();
      };
      window.addEventListener('beforeunload', handleBeforeUnload);
      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
      };
    }, []);

  // Function to get initial details data
  const getInitialDetailsData = () => {
    try {
      const savedDetailsData = localStorage.getItem('maya-form-details');
      if (savedDetailsData) {
        return JSON.parse(savedDetailsData);
      }
    } catch (error) {
      console.warn('Error loading saved details data:', error);
    }
    return {
      //CUSTOMER DETAILS
      name: "",
      contact_no: "",
      email: "",
      call_time: "",

      bumo: "", //FOR INSTORE/OFFSTORE
      patient_type: "", //FOR INCLINIC
      lc_nc_p: "",
      eu_cg: "",
      or_no: "",
      is_diabetasol: "0",
      is_entrasol: "0",
      is_diabetasol_sweetener: "0",
      diabetasol_diagnosis: "",
      entrasol_diagnosis: "",
      diabetasol_sweetener_diagnosis: "",
    };
  };

  const [details, setDetails] = useState(getInitialDetailsData());

  const [checked, setChecked] = useState(false);
  const [checkedDiabetasol, setCheckedDiabetasol] = useState(false);
  const [checkedEntrasol, setCheckedEntrasol] = useState(false);
  const [checkedDiabetasolSweetener, setCheckedDiabetasolSweetener] =
    useState(false);

  const [promoList, setPromoList] = useState([]);
  // const [promoList, setPromoList] = useState([
  //   { name: "DIABETASOL 180g LESS40PHP", qty: 0 },
  //   { name: "DIABETASOL 600g FREEQUAKEROATS", qty: 0 },
  //   { name: "DIABETASOL 600g LESS75PHP", qty: 0 },
  //   { name: "DIABETASOL 800g LESS150PHP", qty: 0 },

  //   { name: "ENTRASOL 200g LESS40PHP", qty: 0 },
  //   { name: "ENTRASOL 600g LESS100PHP", qty: 0 },
  // ]);

  const [promoListLKA, setPromoListLKA] = useState([
    { name: "ENTRASOL 180g LESS40PHP", qty: 0 },
    { name: "ENTRASOL 600g FREEQUAKEROATS", qty: 0 },
    { name: "DIABETASOL 600g LESS75PHP", qty: 0 },
    { name: "DIABETASOL 800g LESS150PHP", qty: 0 },

    { name: "DIABETASOL 200g LESS40PHP", qty: 0 },
    { name: "ENTRASOL 600g LESS100PHP", qty: 0 },
  ]);

  const [freebies, setFreebies] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [malls, setMalls] = useState([]);
  // const [freebies, setFreebies] = useState([
  //   { name: "DIABETASOL", qty: 0 },
  //   { name: "DIABETASOL SWEETENER", qty: 0 },
  //   { name: "ENTRASOL", qty: 0 },
  // ]);
  const [productCodes, setProductCodes] = useState([
    { name: "DIABETASOL SWEET 50x1g", qty: 0 },

    { name: "DIABETASOL-VAN 180g", qty: 0 },
    { name: "DIABETASOL-VAN 360g", qty: 0 },
    { name: "DIABETASOL-VAN 600g", qty: 0 },
    { name: "DIABETASOL-VAN 800g", qty: 0 },
    { name: "DIABETASOL-VAN 1kg", qty: 0 },

    { name: "DIABETASOL-CHO 180g", qty: 0 },
    { name: "DIABETASOL-CHO 360g", qty: 0 },
    { name: "DIABETASOL-CHO 600g", qty: 0 },

    { name: "DIABETASOL-CAP 180g", qty: 0 },
    { name: "DIABETASOL-CAP 600g", qty: 0 },

    { name: "ENTRASOL-VAN 200g", qty: 0 },
    { name: "ENTRASOL-VAN 600g", qty: 0 },

    { name: "ENTRASOL-CHO 200g", qty: 0 },
    { name: "ENTRASOL-CHO 600g", qty: 0 },
  ]);
  const [accounts, setAccounts] = useState([]);

  // Save details state to localStorage whenever it changes
  useEffect(() => {
    try {
      localStorage.setItem('maya-form-details', JSON.stringify(details));
    } catch (error) {
      console.warn('Error saving details data to localStorage:', error);
    }
  }, [details]);

  async function fetchAccounts() {
    try {
      const response = await getAccounts();
      if (response.data) {
        setAccounts(response.data);
      }
    } catch (error) {
      console.log("Failed to fetch accounts:", error);
      // Set empty array as fallback
      setAccounts([]);
    }
  }

  async function fetchDropdownData() {
    try {
      const response = await getDropdownData();
      // console.log(response)
      if (response.data) {
        setCustomers(response.data.customers);
        setMalls(response.data.malls);
      }
    } catch (error) {
      console.log("Failed to fetch dropdown data:", error);
      // Set empty arrays as fallback
      setCustomers([]);
      setMalls([]);
    }
  }

  async function fetchFreebies() {
    try {
      const response = await getFreebies();
      if (response.data) {
        var arr = [];
        response.data.map((data) => {
          arr.push({ ...data, qty: 0 });
        });
        setFreebies(arr);
      }
    } catch (error) {
      console.log("Failed to fetch freebies:", error);
      // Set empty array as fallback
      setFreebies([]);
    }
  }

  async function fetchPromos() {
    try {
      const response = await getPromos(
        primaryDetails.activation_type,
        primaryDetails.classification_type
      );
      if (response.data) {
        var arr = [];
        response.data.map((data) => {
          arr.push({ ...data, qty: 0 });
        });
        setPromoList(arr);
      }
    } catch (error) {
      console.log("Failed to fetch promos:", error);
      // Set empty array as fallback
      setPromoList([]);
    }
  }

  useEffect(() => {
    // Temporarily disabled to avoid 404 errors
    // fetchDropdownData();
    // fetchFreebies();
    // fetchAccounts();
  }, []);

  useEffect(() => {
    // Temporarily disabled to avoid 404 errors
    // if (
    //   primaryDetails.classification_type !== "" &&
    //   primaryDetails.activation_type !== ""
    // ) {
    //   fetchPromos();
    // }
  }, [primaryDetails.classification_type]);
  useEffect(() => {
    // Temporarily disabled to avoid 404 errors
    // if (
    //   primaryDetails.classification_type !== "" &&
    //   primaryDetails.activation_type !== ""
    // ) {
    //   fetchPromos();
    // }
  }, [primaryDetails.activation_type]);

  // Function to handle primary details updates with logging
  const setPrimaryDetailsWithLogging = (newDetails) => {
    // Support both function and object updates
    if (typeof newDetails === 'function') {
      setPrimaryDetails((prev) => {
        const updated = newDetails(prev);
        console.log('Updating primary details:', updated);
        return updated;
      });
    } else {
      console.log('Updating primary details:', newDetails);
      setPrimaryDetails(newDetails);
    }
  };

  // Enhanced navigation with form reset capability
  const enhancedNavigation = {
    ...navigation,
    clearFormData,
  };

  // ...existing code...
  const mayaFormProps = {
    navigation: enhancedNavigation,
    primaryDetails,
    setPrimaryDetails: setPrimaryDetailsWithLogging,
  };

  const merchantDetailsProps = {
    navigation: enhancedNavigation,
    primaryDetails,
    setPrimaryDetails: setPrimaryDetailsWithLogging,
  };

  // Unified props for region and mall components
  const unifiedRegionProps = {
    navigation: enhancedNavigation,
    primaryDetails,
    setPrimaryDetails: setPrimaryDetailsWithLogging,
  };

  const merchantLocationProps = {
    navigation: enhancedNavigation,
    primaryDetails,
    setPrimaryDetails: setPrimaryDetailsWithLogging,
  };

  const registrationProps = {
    navigation: enhancedNavigation,
    details,
    setDetails,
    primaryDetails,
    setPrimaryDetails: setPrimaryDetailsWithLogging,
    accounts,
    setAccounts,
    malls,
    setMalls,
    customers,
    setCustomers,
    issues,
    outlets,
    selectedEscalationIssues,
    setSelectedEscalationIssues
  };
  const consumerProps = {
    navigation: enhancedNavigation,
    details,
    setDetails,
    primaryDetails,
    productCodes,
    setProductCodes,
    freebies,
    setFreebies,
    promoList,
    setPromoList,
    promoListLKA,
    setPromoListLKA,
    checked,
    setChecked,
    checkedDiabetasol,
    setCheckedDiabetasol,
    checkedEntrasol,
    setCheckedEntrasol,
    checkedDiabetasolSweetener,
    setCheckedDiabetasolSweetener,
    malls,
    setMalls,
    customers,
    setCustomers,
  };
  const summaryProps = {
    navigation: enhancedNavigation,
    details,
    primaryDetails,
    productCodes,
    freebies,
    promoList,
    promoListLKA,
    addCustomer,
    setAddCustomer,
    formId,
    setFormId,
    checked,
    setChecked,
    checkedDiabetasol,
    setCheckedDiabetasol,
    checkedEntrasol,
    setCheckedEntrasol,
    checkedDiabetasolSweetener,
    setCheckedDiabetasolSweetener,
    malls,
    setMalls,
    customers,
    setCustomers,
    issues,
    outlets,
    selectedEscalationIssues,
    setSelectedEscalationIssues
  };

  // Terminal and defective details state for MayaSolution and MayaTerminalSolutionDetails
  const [terminalDetails, setTerminalDetails] = useState({
    terminal_available: '',
    poa: '',
    terminal_model: [],
    card_efs: '',
    qr_efs: '',
    not_obtaining_mid_reason: [],
    other_reason_no_mid: '',
    is_defective: '',
  });
  const [terminalError, setTerminalError] = useState({});
  
  // Sync terminalDetails from primaryDetails on mount or when primaryDetails changes
  useEffect(() => {
    if (primaryDetails.terminal_available || primaryDetails.poa) {
      setTerminalDetails((prev) => ({
        ...prev,
        terminal_available: primaryDetails.terminal_available || prev.terminal_available,
        poa: primaryDetails.poa || prev.poa,
        terminal_model: primaryDetails.terminal_model || prev.terminal_model,
        card_efs: primaryDetails.card_efs || prev.card_efs,
        qr_efs: primaryDetails.qr_efs || prev.qr_efs,
        not_obtaining_mid_reason: primaryDetails.not_obtaining_mid_reason || prev.not_obtaining_mid_reason,
        other_reason_no_mid: primaryDetails.other_reason_no_mid || prev.other_reason_no_mid,
        is_defective: primaryDetails.is_defective || prev.is_defective,
      }));
    }
  }, [primaryDetails.terminal_available, primaryDetails.poa]);
  
  const TERMINAL_MODELS = ['SUNMI', 'A920', 'A50'];
  const REASON_NO_MID = [
    'Needs management approval first',
    'HO restriction',
    'Data privacy',
    'Defective terminal',
    'Other reason',
  ];
  const handleTerminalChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox') {
      if (name === 'terminal_model') {
        const newValue = checked
          ? [...terminalDetails.terminal_model, value]
          : terminalDetails.terminal_model.filter((v) => v !== value);
        setTerminalDetails((prev) => ({
          ...prev,
          terminal_model: newValue,
        }));
        setPrimaryDetails((prev) => ({ ...prev, terminal_model: newValue }));
      } else if (name === 'not_obtaining_mid_reason') {
        const newValue = checked
          ? [...terminalDetails.not_obtaining_mid_reason, value]
          : terminalDetails.not_obtaining_mid_reason.filter((v) => v !== value);
        setTerminalDetails((prev) => ({
          ...prev,
          not_obtaining_mid_reason: newValue,
        }));
        setPrimaryDetails((prev) => ({ ...prev, not_obtaining_mid_reason: newValue }));
      }
    } else {
      setTerminalDetails((prev) => ({ ...prev, [name]: value }));
      setPrimaryDetails((prev) => ({ ...prev, [name]: value }));
    }
    if (terminalError[name]) {
      setTerminalError((prev) => ({ ...prev, [name]: false }));
    }
  };
  const [defectiveDetails, setDefectiveDetails] = useState({
    defective_count: '',
    defective_terminal_ids: '',
    defective_serial_nos: '',
    escalation_case_no: '',
  });
  const [defectiveError, setDefectiveError] = useState({});
  const handleDefectiveChange = (e) => {
    const { name, value } = e.target;
    setDefectiveDetails((prev) => ({ ...prev, [name]: value }));
    if (defectiveError[name]) {
      setDefectiveError((prev) => ({ ...prev, [name]: false }));
    }
  };

  async function fetchMerchants(){
    const response = await getAllMerchants()
      let issues_final = []
    if(response?.data){

      response.data.data.map(val=>{
        issues_final.push({...val, 	name: "merchant_id",
      var_name: "merchant_name",
      label: val.name,
      value: val.id,})
      })

    }
      issues_final.push(	{
      name: "merchant_id",
      var_name: "merchant_name",
      label: "Others",
      value: "Others",
    })
      setIssues(issues_final)

  }
  async function fetchOutlets(){
    const response = await getAllOutlets()
      let outlets_final = []
    if(response?.data){

      response.data.data.map(val=>{
        outlets_final.push({...val, 	name: "outlet_id",
      var_name: "outlet",
      label: val.name,
      value: val.id,})
      })

    }
      outlets_final.push(	{

      name: "outlet_id",
      var_name: "outlet",
      label: "Others",
      value: "Others",

    })
      setOutlets(outlets_final)

  }
  useEffect(()=>{
    // Temporarily disabled to avoid 404 errors
    // fetchMerchants()
    // fetchOutlets()
  },[])
  switch (step.id) {
    case "terminal-stickering":
      return (
        <TerminalStickering
          primaryDetails={primaryDetails}
          setPrimaryDetails={setPrimaryDetailsWithLogging}
          navigation={{
            ...enhancedNavigation,
            next: () => {
              // Go to different steps based on primaryDetails.no_stickered_reason or other field
              if (primaryDetails.no_stickered_reason === "Terminal has been stickered already" || primaryDetails.no_stickered_reason === "HO restriction" || primaryDetails.no_stickered_reason === "Old terminal model" || primaryDetails.no_stickered_reason === "Defective terminal" || primaryDetails.no_stickered_reason === "Sticker does not fit" || primaryDetails.no_stickered_reason === "Merchant refused" || primaryDetails.no_stickered_reason === "TAS has no on-hand terminal sticker" || primaryDetails.no_stickered_reason === "Other reasons") {
                enhancedNavigation.go('thermal-roll');
              } else {
                enhancedNavigation.next(); // fallback to next step
              }
            }
          }}
          // stickeringDetails={stickeringDetails}
          // setStickeringDetails={setStickeringDetails}
          stickeringError={stickeringError}
          setStickeringError={setStickeringError}
        />
      );
    case "maya-form":
      return <MayaGoogleForm {...mayaFormProps} />;
    case "merchant-details":
      return <MerchantDetails {...merchantDetailsProps} />;
    case "region-form":
      return <RegionForm {...unifiedRegionProps} selectedRegion={primaryDetails.region} />;
    case "mall-selector":
      return <MallSelector {...unifiedRegionProps} selectedRegion={primaryDetails.region} />;
    case "other-mall-details":
      return <OtherMallDetails {...unifiedRegionProps} />;
    case "industry-type-store":
      return <IndustryTypeStore {...unifiedRegionProps} />;
    case "can-engage":
      return <CanEngage {...unifiedRegionProps} />;
    case "cant-engage-remarks":
      return <CantEngageRemarks {...unifiedRegionProps} />;
    case "type-of-merchant":
      return <TypeOfMerchant {...unifiedRegionProps} />;
    case "non-maya-merchants-survey":
      return <NonMayaMerchantsSurvey {...unifiedRegionProps} />;
    case "maya-solution":
      return (
        <MayaSolution
          {...unifiedRegionProps}
          terminalDetails={terminalDetails}
          setTerminalDetails={setTerminalDetails}
          terminalError={terminalError}
          setTerminalError={setTerminalError}
          TERMINAL_MODELS={TERMINAL_MODELS}
          REASON_NO_MID={REASON_NO_MID}
          handleTerminalChange={handleTerminalChange}
          defectiveDetails={defectiveDetails}
          setDefectiveDetails={setDefectiveDetails}
          defectiveError={defectiveError}
          setDefectiveError={setDefectiveError}
          handleDefectiveChange={handleDefectiveChange}
        />
      );
    case "terminal-availability":
      return <TerminalAvailability {...unifiedRegionProps} />;
    case "sqr-availability":
      return <SQRAvailability {...unifiedRegionProps} />;
    case "terminal-concerns":
      return <TerminalConcerns {...unifiedRegionProps} />;
    case "zero-to-low-merchant":
      return <ZeroToLowMerchant {...unifiedRegionProps} />;
    case "zero-to-low-merchant-yes":
      return <ZeroToLowMerchantYes {...unifiedRegionProps} />;
    case "visibility-photo":
      return <VisibilityPhoto {...unifiedRegionProps} />;
    case "revisit-details":
      return <RevisitDetails {...unifiedRegionProps} />;
    case "dcc-flyer":
      return <DCCFlyer {...unifiedRegionProps} />;
    case "dcc-flyer-photo":
      return <DCCFlyerPhoto {...unifiedRegionProps} />;
    case "maya-kita-club-flyer":
      return <MayaKitaClubFlyer {...unifiedRegionProps} />;
    case "maya-kita-club-flyer-photo":
      return <MayaKitaClubFlyerPhoto {...unifiedRegionProps} />;
    case "troubleshoot-qr-sticker":
      return <TroubleshootQRSticker {...unifiedRegionProps} />;
    case "troubleshoot-qr-sticker-photo":
      return <TroubleshootQRStickerPhoto {...unifiedRegionProps} />;
    case "troubleshoot-p1-sticker":
      return <TroubleShootP1Sticker {...unifiedRegionProps} />;
    case "troubleshoot-p1-sticker-photo":
      return <TroubleshootP1StickerPhoto {...unifiedRegionProps} />;
    case "remarks":
      return <Remarks {...unifiedRegionProps} />;
    case "promotional-activity":
      return <PromotionalActivity {...unifiedRegionProps} />;
    case "awarding-merienda":
      return <AwardingMerienda {...unifiedRegionProps} />;
    case "awarding-feedback":
      return <AwardingFeedback {...unifiedRegionProps} />;
    case "awarding-maya-credit":
      return <AwardingMayaCredit {...unifiedRegionProps} />;
    case "awarding-details":
      return <AwardingDetails {...unifiedRegionProps} />;
    case "awarding-flagship":
      return <AwardingFlagship {...unifiedRegionProps} />;
    case "flagship-feedback":
      return <FlagshipFeedback {...unifiedRegionProps} />;
    case "competitor-merch":
      return <CompetitorMerch {...unifiedRegionProps} />;
    case "competitor-promo-consumers":
      return <CompetitorPromoConsumers {...unifiedRegionProps} />;
    case "competitor-promo-merchant":
      return <CompetitorPromoMerchant {...unifiedRegionProps} />;
    case "working-terminal-details":
      return <WorkingTerminalDetails {...unifiedRegionProps} TERMINAL_MODELS={TERMINAL_MODELS} terminalDetails={terminalDetails} navigation={{
        ...enhancedNavigation,
        next: () => {
          if (primaryDetails.is_stickered === 'Yes') {
            enhancedNavigation.go('terminal-stickering-details');
          } else if (primaryDetails.is_stickered === 'No') {
            enhancedNavigation.go('terminal-stickering');
          }
        }
      }} />;
    case "thermal-roll":
      return (
        <ThermalRoll
          {...unifiedRegionProps}
          navigation={enhancedNavigation}
          primaryDetails={primaryDetails}
          setPrimaryDetails={setPrimaryDetailsWithLogging}
        />
      );
    case "thermal-roll-delivery-yes":
      return (
        <ThermalRollDeliveryPage
          {...unifiedRegionProps}
          navigation={enhancedNavigation}
          primaryDetails={primaryDetails}
          setPrimaryDetails={setPrimaryDetailsWithLogging}
          errors={{}}
        />
      );
    case "charger-delivery":
      return (
        <ChargerDelivery
          {...unifiedRegionProps}
          navigation={enhancedNavigation}
          primaryDetails={primaryDetails}
          setPrimaryDetails={setPrimaryDetailsWithLogging}
        />
      );
    case "charger-delivery-yes":
      return (
        <ChargerDeliveryYesPage
          {...unifiedRegionProps}
          navigation={enhancedNavigation}
          primaryDetails={primaryDetails}
          setPrimaryDetails={setPrimaryDetailsWithLogging}
        />
      );
    case "p1-standee-merchandising":
      return <P1StandeeMerchandisingPage {...unifiedRegionProps} />;
    case "not-visible-p1-standee":
      return <NotVisibleP1Standee {...unifiedRegionProps} />;
    case "p1-standee-details":
      return <P1StandeeDetails {...unifiedRegionProps} />;
    case "p1-door-hanger-merchandising":
      return <P1DoorHangerMerchandisingPage {...unifiedRegionProps} />;
    case "not-visible-p1-door-hanger":
      return <NotVisibleP1DoorHangerPage {...unifiedRegionProps} />;
    case "p1-door-hanger-details":
      return <P1DoorHangerDetailsPage {...unifiedRegionProps} />;
    case "p1-door-sticker-merchandising":
      return <P1DoorStickerMerchandisingPage {...unifiedRegionProps} />;
    case "p1-door-sticker-details":
      return <P1DoorStickerDetails {...unifiedRegionProps} />;
    case "not-visible-p1-door-sticker":
      return <NotVisibleP1DoorStickerPage {...unifiedRegionProps} />;
    case "install-p1-terminal-merch":
      return <InstallP1TerminalMerch {...unifiedRegionProps} />;
    case "installed-p1-door-sticker":
      return <InstalledP1DoorSticker {...unifiedRegionProps} />;
    case "not-installed-p1-door-sticker":
      return <NotInstalledP1DoorSticker {...unifiedRegionProps} />;
    case "maya-sqr-solution":
      return <MayaSQRSolution {...unifiedRegionProps} />;
    case "maya-sqr-solution-details":
      return <MayaSQRSolutionDetails {...unifiedRegionProps} />;
    case "merchandising":
      return <Merchandising {...unifiedRegionProps} />;
    case "maya-black":
      return <MayaBlack {...unifiedRegionProps} />;
    case "merchant-other-solution":
      return <MerchantOtherSolution {...unifiedRegionProps} />;  
    case "visibility-of-terminal-merch":
      return <VisibilityOfTerminalMerch {...unifiedRegionProps} />;
    case "visibility-of-sqr-merch":
      return <VisibilityOfSQRMerch {...unifiedRegionProps} />;
    case "updated-sqr":
      return <UpdatedSQR {...unifiedRegionProps} />;
    case "sqr-branding-version":
      return <SQRBrandingVersion {...unifiedRegionProps} />;
    case "sqr-photo":
      return <SQRPhoto {...unifiedRegionProps} />;
    case "qrph-door-hanger-merch":
      return <QRPHDoorHangerMerch {...unifiedRegionProps} />;
    case "qrph-door-hanger-details":
      return <QRPHDoorHangerDetails {...unifiedRegionProps} />;
    case "qrph-door-sticker-merch":
      return <QRPHDoorStickerMerch {...unifiedRegionProps} />;
    case "qrph-door-sticker-details":
      return <QRPHDoorStickerDetails {...unifiedRegionProps} />;
    case "not-visible-qrph-door-sticker":
      return <NotVisibleQRPHDoorSticker {...unifiedRegionProps} />;
    case "installed-qrph-door-sticker":
      return <InstalledQRPHDoorSticker {...unifiedRegionProps} />;
    case "not-installed-qrph-door-sticker":
      return <NotInstalledQRPHDoorSticker {...unifiedRegionProps} />;
    case "install-sqr-merch":
      return <InstallSQRMerch {...unifiedRegionProps} />;
    case "qrph-knowledge":
      return <QRPHKnowledge {...unifiedRegionProps} />;
    case "not-visible-qrph":
      return <NotVisbleQRPH {...unifiedRegionProps} />;
    case "interested-maya-solution":
      return <InterestedMayaSolution {...unifiedRegionProps} />;
    case "non-maya-merchant-info":
      return <NonMayaMerchantInfo {...unifiedRegionProps} />;
    case "not-interested-maya-solution":
      return <NotInterestedMayaSolution {...unifiedRegionProps} />;
    case "merchant-location":
      return <MerchantLocation {...merchantLocationProps} />;
    case "maya-mall-program-cip":
      return <MayaMallProgramCIP {...unifiedRegionProps} />;
    case "maya-mall-program-section-70":
      return <MayaMallProgramSection70 {...unifiedRegionProps} />;
    
    case "competitor-priority":
      return <CompetitorPriority {...unifiedRegionProps} />;
    case "joining-maya-mall-program-section-72":
      return <JoiningMayaMallProgramSection72 {...unifiedRegionProps} />;
    case "not-joining-maya-mall-program":
      return <NotJoiningMayaMallProgram {...unifiedRegionProps} />;
    case "point-of-contact":
      return <PointOfContact {...unifiedRegionProps} />;
    case "viber-account":
      return <ViberAccount {...unifiedRegionProps} />;
    case "maya-account":
      return <MayaAccount {...unifiedRegionProps} />;
    case "maya-account-details":
      return <MayaAccountDetails {...unifiedRegionProps} />;
    case "maya-kita-club":
      return <MayaKitaClub {...unifiedRegionProps} />;
    case "handling-and-merchant-concerns":
      return <HandlingAndMerchantConcerns {...unifiedRegionProps} />;
    case "maya-merchant-survey":
      return <MayaMerchantSurvey {...unifiedRegionProps} />;
    case "registration":
      return <RegistrationVer2 {...registrationProps} />;
    // case "consumer":
    //   return <Consumer {...consumerProps} />;
    case "summary":
      return <SummaryVer2 {...summaryProps} />;
    case "maya-terminal-solution-details":
      return (
        <MayaTerminalSolutionDetails
          {...unifiedRegionProps}
          navigation={{
            ...enhancedNavigation,
            next: () => {
              // If has defective terminal is Yes, go to defective-terminal-details, else go to working-terminal-details
              if (terminalDetails.is_defective === 'Yes') {
                enhancedNavigation.go('defective-terminal-details');
              } else {
                enhancedNavigation.go('working-terminal-details');
              }
            }
          }}
          terminalDetails={terminalDetails}
          setTerminalDetails={setTerminalDetails}
          terminalError={terminalError}
          setTerminalError={setTerminalError}
          TERMINAL_MODELS={TERMINAL_MODELS}
          REASON_NO_MID={REASON_NO_MID}
          handleTerminalChange={handleTerminalChange}
        />
      );
    case "defective-terminal-details":
      return (
        <DefectiveTerminalDetails
          {...unifiedRegionProps}
          navigation={enhancedNavigation}
          defectiveDetails={defectiveDetails}
          setDefectiveDetails={setDefectiveDetails}
          defectiveError={defectiveError}
          setDefectiveError={setDefectiveError}
          handleDefectiveChange={handleDefectiveChange}
        />
      );
    case "terminal-stickering-details":
      return (
        <TerminalStickeringDetails
          {...unifiedRegionProps}
          navigation={enhancedNavigation}
          details={primaryDetails}
          handleChange={(e) => {
          const { name, value, type } = e.target;
          if (type !== "file") {
            setPrimaryDetails((prev) => ({
              ...prev,
              [name]: value,
            }));
          }
          // photos handled by PhotoUploadField now
        }}
          errors={{}}
        />
      );
    case "wasted-terminal-sticker":
      return (
        <WastedTerminalSticker
          {...unifiedRegionProps}
          navigation={enhancedNavigation}
          details={primaryDetails}
          handleChange={(e) => {
          const { name, value, type } = e.target;
          if (type !== "file") {
            setPrimaryDetails((prev) => ({
              ...prev,
              [name]: value,
            }));
          }
          // photos handled by PhotoUploadField now
        }}
        />
      );

    default:
      return <div></div>;
  }
}

export default SwitchForm;
